import { render, staticRenderFns } from "./project_tag_list.vue?vue&type=template&id=a9c38c0a&scoped=true"
import script from "./project_tag_list.vue?vue&type=script&lang=js"
export * from "./project_tag_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9c38c0a",
  null
  
)

export default component.exports